<template lang="pug">
v-app
  vertical-nav-menu(:is-drawer-open.sync='isDrawerOpen')

  v-app-bar(app flat absolute color='transparent')
    .boxed-container.w-full
      .d-flex.align-center.mx-6

        //- Left Content
        v-app-bar-nav-icon.d-block.me-2(@click='isDrawerOpen = !isDrawerOpen')
        //- v-text-field.app-bar-search.flex-grow-0(
        //-   rounded dense outlined hide-details
        //-   :prepend-inner-icon='icons.mdiMagnify'
        //- )

        v-spacer

        //- Right Content
        //- a(href='https://github.com/themeselection/materio-vuetify-vuejs-admin-template-free' target='_blank' rel='nofollow')
        //-   v-icon.ms-6.me-4
        //-     | {{ icons.mdiGithub }}
        theme-switcher

        //- Seleção de Aplicativo
        v-tooltip(:bottom="!$vuetify.rtl")
          template(#activator="{ on, attrs }")
            v-btn.ms-3(
              v-bind="attrs"
              v-on="on"
              icon
              small
              :to="$to('Index.Workspace')"
            )
              v-icon mdi-apps
          span
            span.text-md.font-weight-medium Aplicativos
            br
            span.font-weight-light Exibe a lista de aplicativos disponíveis para o sítio corrente.

        //- Seleção de Sítio
        v-tooltip(:bottom="!$vuetify.rtl")
          template(#activator="{ on, attrs }")
            v-btn.ms-3(
              v-bind="attrs"
              v-on="on"
              icon
              small
              :to="$to({ site: 'Home', eref: 'Home.Sitios' })"
            )
              v-icon mdi-domain
          span
            span.text-md.font-weight-medium Sítios
            br
            span.font-weight-light Exibe a lista de sítios disponíveis no barramento.

        //- Notificações
        v-tooltip(:bottom="!$vuetify.rtl")
          template(#activator="{ on, attrs }")
            v-btn.ms-3(
              v-bind="attrs"
              v-on="on"
              icon
              small
              :to="$to('Index.Workspace')"
            )
              v-icon mdi-bell-outline

          span
            span.text-md.font-weight-medium Notíficações
            br
            span.font-weight-light (Nenhuma notificação por enquanto.)

        app-bar-user-menu

  v-main
    .app-content-container.boxed-container.pa-6
      slot

  v-footer.x-rodape.x-no-wrap.px-0(
    v-if="isFooterVisible"
    app inset absolute
    color='transparent'
    height='56'
  )
    .boxed-container.w-full
      .mx-6.d-flex.justify-space-between

        //- Conteúdo à esquerda
        span.x-no-wrap
          span.x-rodape-item
            span.font-weight-thin {{ $app.title }}
            span &nbsp;
            span.font-weight-thin {{ revisao }}
            span &nbsp;

          span.x-rodape-item(v-if="info.copyright")
            span.font-weight-thin {{ info.copyright }}
            span &nbsp;

          span.x-rodape-link(v-if="info.developer")
            span.font-weight-thin
              template(v-if="info.website")
                a.text-decoration-none(:href="info.website" target='_blank')
                  | {{ info.developer }}

              template(v-else)
                | {{ info.developer }}
            span &nbsp;

        //- Conteúdo à direita
        span.x-rodape-item(v-if="info.status")
          span &nbsp;
          span.font-weight-thin.d-sm-inline.d-none
            span.text--secondary.text-decoration-none {{ info.status }}
</template>

<style scoped>
.x-rodape {
  font-size: 0.85em;
  font-family: serif;
}
.x-rodape-item {
  opacity: 0.5;
}
.x-rodape-link {
  opacity: 0.5;
}
.x-rodape-link:hover {
  opacity: 1.0;
}
.x-no-wrap {
  white-space: nowrap;
}
</style>

<style lang="scss" scoped>
.v-app-bar ::v-deep {
  .v-toolbar__content {
    padding: 0;

    .app-bar-search {
      .v-input__slot {
        padding-left: 18px;
      }
    }
  }
}

.boxed-container {
  margin-left: auto;
  margin-right: auto;
}
</style>

<script>
import { mdiMagnify, mdiBellOutline, mdiGithub } from '@mdi/js'
import VerticalNavMenu from './components/vertical-nav-menu/VerticalNavMenu.vue'
import ThemeSwitcher from './components/ThemeSwitcher.vue'
import AppBarUserMenu from './components/AppBarUserMenu.vue'
import AppTitle from  "@/components/commons/layout/AppTitle"

import { SYSTEM, MENU, SET_MENU } from "@/store/mutation-types";

export default {
  components: {
    VerticalNavMenu,
    ThemeSwitcher,
    AppBarUserMenu,
    AppTitle,
  },

  props: {
    /**
     * Configurações da área de trabalho corrente.
     *
     * @type {Keep.Paper.Design.Workspace}
     */
    workspace: Object,
  },

  data: () => ({
    revisao: null,

    // isDrawerOpen: null,
    isFooterVisible: true,

    icons: {
      mdiMagnify,
      mdiBellOutline,
      mdiGithub,
    }
  }),

  computed: {
    info () {
      const dataSet = this.workspace?.dataSet?.sets
      const infoSet = dataSet?.filter(set => set.name?.toLowerCase() === 'info')[0]
      const info = infoSet?.rows?.[0] || {}
      const year = new Date().getFullYear()
      info.copyright ||= `© ${year}`
      info.developer ||= 'Processa Sistemas'
      info.website ||= 'https://processasistemas.com.br/'
      return info
    },

    isDrawerOpen: {
      get () {
        return this.$store.state[SYSTEM][MENU]
      },
      set (value) {
        this.$store.commit(SET_MENU, value)
      }
    }
  },

  async created() {
    this.revisao = await this.$revisao;
  },
}
</script>
